import axios from "axios";

export const HTTPClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json;charset=UTF-8",
    }
})